/**
 * This indicates what type of contract we are using to deploy a given edition.
 * If we need to add a new version of Kits_721, just call it KITS_721_V2.
 */
export enum EditionContractType {
  /**
   * The 721 Kits contract used to deploy our first Kits contracts.
   * Example:
   * https://etherscan.io/address/0x704ac9e6ddc270d71ca52bf4bdae6817efacb10b#readProxyContract
   */
  KITS_721 = 'kits-erc721',
  /** https://docs.decent.xyz/docs/series */
  DECENT_1155 = 'decent-erc1155',
  /** https://docs.decent.xyz/docs/edition */
  DECENT_721 = 'decent-erc721'
}
